var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteeringWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_4858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3955 0C5.61914 0 0.895508 4.72363 0.895508 10.5C0.895508 16.2764 5.61914 21 11.3955 21C17.1719 21 21.8955 16.2764 21.8955 10.5C21.8955 4.72363 17.1719 0 11.3955 0ZM11.3955 2.625C14.458 2.625 17.1719 4.375 18.4844 7C18.7441 7.52637 18.2212 8.04932 17.6948 7.78613C16.2969 7.08887 13.9316 6.21387 11.3955 6.21387C8.85938 6.21387 6.49414 7.08887 5.09619 7.78613C4.65869 8.04932 4.13232 7.52637 4.30664 7C5.61914 4.375 8.33301 2.625 11.3955 2.625ZM9.73438 17.7632C9.73438 18.0264 9.47119 18.2007 9.29688 18.1118C6.67188 17.4111 4.56982 15.3125 3.86914 12.6875C3.78369 12.4243 3.95801 12.25 4.22119 12.25H4.30664C7.28369 12.1611 9.73438 14.6118 9.73438 17.7632ZM11.3955 12.6875C10.1719 12.6875 9.20801 11.7236 9.20801 10.5C9.20801 9.27637 10.1719 8.3125 11.3955 8.3125C12.6191 8.3125 13.583 9.27637 13.583 10.5C13.583 11.7236 12.6191 12.6875 11.3955 12.6875ZM13.4941 18.1118C13.2344 18.2007 13.0566 18.0264 13.0566 17.7632V17.6743C13.0566 14.6118 15.5073 12.1611 18.5698 12.1611H18.6587C18.9219 12.1611 19.0962 12.4243 19.0073 12.5986C18.2212 15.2236 16.1191 17.3257 13.4941 18.1118Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_4858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.895508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteeringWheel);
export default __webpack_public_path__ + "static/media/steering-wheel.833bb676b793114f4fa46d887bfb4336.svg";
export { ForwardRef as ReactComponent };